import ee from '../../../third_party/ee_api_js_modified';
import addLoaded from './addLoaded';

/**
 * StaticRaserManager to handle backend only elevation change.
 * @implements {google.maps.MapType}
 */
export default class StaticRasterManager extends ee.layers.RasterManager {
  /**
   * @param {!Object} props Properties.
   * @param {!float} altitude current altitude.
   * @param {!Map} map Google Map instance.
   * @param {!function} updateProgress, updateLoading progress.
   */
  constructor(props) {
    super(props);

    const {
      altitude,
      blur = 0,
      map,
      updateProgress,
    } = props;

    this.altitude = altitude;
    this.blur = blur;
    this.map = map;
    this.updateProgress = updateProgress;
    this.overlay = null;
  }

  /**
   * @param {!number} blur Blur of the tile.
   */
  setBlur(blur) {
    this.blur = blur;
  }

  /**
   * @param {!RasterOverlay} overlay Raster overlay.
   */
  setOverlay(overlay) {
    this.overlay = overlay;
  }

  /**
   * Set current progress loading tiles.
   */
  setProgress() {
    const { activeTiles, updateProgress } = this;
    const ratio = activeTiles.reduce(addLoaded, 0) / activeTiles.length;
    updateProgress(ratio * 100);
  }

  /**
   * @param {!RasterTile} tile Tile to be processed.
   * @return {HTMLCanvasElement} Processed displayable image.
   */
  processRasterTile(tile) {
    tile.isRasterUpdated = true; // eslint-disable-line no-param-reassign
    this.setProgress();
    return tile.imageEl;
  }

  /**
   * Set clip value from altitude.
   * @param {!number} altitude Sea level rice indicator.
   */
  setClip(altitude) {
    this.altitude = altitude;
  }

  /**
   * Update raster tiles.
   */
  update() {
    this.map.overlayMapTypes.setAt(0, this.overlay);
  }
}
